import { Controller } from '@hotwired/stimulus'
import Logger from '../lib/logger'

export default class extends Controller {
  static targets = ['segment']

  connect() {
    Logger.debug('MobileProgressController connected')
  }

  disconnect() {
    Logger.debug('MobileProgressController disconnected')
  }

  filterSegment(event) {
    // Segment filtering is handled by the link's default behavior
    // This controller can be extended with custom filtering logic
    Logger.debug('Segment clicked:', event.currentTarget)
  }
}